import React from 'react';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

import { HEIGHT, WIDTH } from '../DedicatedEventCard';

export const DedicatedEventCardSkeleton = () => {
    return (
        <Box height={HEIGHT} width={WIDTH} alignItems="center" justifyContent={'center'}>
            <Box backgroundColor={ds.colorToken.background.neutral.subtler} borderRadius={'r16'}>
                <LoadingSkeleton
                    skeletonColor={designSystem.colors.neutral300}
                    width={WIDTH}
                    height={HEIGHT}
                    borderRadius={'r16'}
                />
            </Box>
        </Box>
    );
};
